import { render, staticRenderFns } from "./CorporateUserValidate.vue?vue&type=template&id=3552c060&scoped=true&"
import script from "./CorporateUserValidate.vue?vue&type=script&lang=ts&"
export * from "./CorporateUserValidate.vue?vue&type=script&lang=ts&"
import style0 from "./CorporateUserValidate.vue?vue&type=style&index=0&id=3552c060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3552c060",
  null
  
)

export default component.exports